import { ChildSubMenuGroup, Course, Genre, Menu, MenuBook, SubGenre, SubMenu, SubMenuGroup } from '../../models';
import ChildSubMenuRow from '../ChildSubMenuRow';

export interface ChildSubMenuRowListProps {
  menuBook: MenuBook;
  course?: Course;
  genre: Genre;
  subgenre: SubGenre;
  menu: Menu;
  subMenuGroup: SubMenuGroup;
  subMenu: SubMenu;
  childSubMenuGroup: ChildSubMenuGroup;
}

function ChildSubMenuRowList({
  menuBook,
  course,
  genre,
  subgenre,
  menu,
  subMenuGroup,
  subMenu,
  childSubMenuGroup,
}: ChildSubMenuRowListProps) {
  return (
    <>
      {childSubMenuGroup.child_sub_menus.map((childSubMenu) => (
        <ChildSubMenuRow
          key={`childsubmenu-${childSubMenu.id}`}
          menuBook={menuBook}
          course={course}
          genre={genre}
          subgenre={subgenre}
          menu={menu}
          subMenuGroup={subMenuGroup}
          subMenu={subMenu}
          childSubMenuGroup={childSubMenuGroup}
          childSubMenu={childSubMenu}
        ></ChildSubMenuRow>
      ))}
    </>
  );
}

export default ChildSubMenuRowList;
